const _85 = "21.25rem"
const _120 = "30rem"
const _130 = "32.5rem"
const _170 = "42.5rem"
const config = { "85": _85, "120": _120, "130": _130, "170": _170,  }
export { config as default, _85, _120, _130, _170 }